<template>
  <div>
    <vxe-grid
      ref="table"
      border="inner"
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :checkbox-config="checkboxConfig"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      row-id="subgroupMemberCode"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>
      <template #pager>
        <slot name="pager"></slot>
      </template>
      <template #opt="{ row }">
        <el-tooltip
          v-if="allow('D')"
          effect="dark"
          :content="$l('tooltip_del_user') || '删除成员'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="deleteItem(row)"> </i>
        </el-tooltip>
      </template>
      <template #empty>
        <div class="text-center">
          <img src="/image/static/img/nodata.png" />
          <p class="m-0 mt-2">
            {{ $l("INDEX.table_label_empty") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from "./TableColumns";
import TableAutoHeight from "@/mixins/table-auto-height";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  inject: ["group-content-height"],
  data() {
    return {
      tableToolbar: {
        slots: { buttons: "toolbar_form" },
      },
      setContentHeight: () => {},
      checkboxConfig: {
        checkRowKeys: [],
        highlight: true,
        reserve: false,
      },
      columns: tableColumns(this),
    };
  },
  created() {
    if (this["group-content-height"]) {
      this.setContentHeight = this["group-content-height"].setContentHeight;
    }
  },
  watch: {
    tableHeight() {
      if (this.tableHeight) {
        this.setContentHeight(this.tableHeight);
      }
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit("checkboxChange", records.concat(reserves));
    },
    clearCheckboxRow() {
      if (this.$refs.table) {
        this.$refs.table.clearCheckboxRow();
        this.$refs.table.clearCheckboxReserve();
      }
      this.$emit("checkboxChange", []);
    },
    deleteItem({ subgroupMemberCode }) {
      this.$emit("deleteItems", [subgroupMemberCode]);
    },
    openEditForm(row) {
      this.$emit("openEditForm", row);
    },
    cellClick({ row, column }) {
      const { property } = column;
      const filterColumns = ["checkbox", "col-opt"];
      if (filterColumns.includes(property)) return;

      const $table = this.$refs.table;
      if ($table) {
        $table.toggleCheckboxRow(row);
        const data = $table
          .getCheckboxRecords(true)
          .concat($table.getCheckboxReserveRecords(true));
        this.$emit("checkboxChange", data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
